// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".barTitle[data-v-b777c97a]{position:absolute;top:65px;left:10p;margin-left:10px;font-size:12px;color:#666}[data-v-b777c97a] .el-card__header{padding:8px 15px}.card-count[data-v-b777c97a] .el-card__body{padding:0}.tj-num[data-v-b777c97a]{margin-bottom:0}.tj-num[data-v-b777c97a]:nth-child(2),.tj-num[data-v-b777c97a]:nth-child(3){background:#f8f8f8}.color-black[data-v-b777c97a]{color:#303133}.color-green[data-v-b777c97a]{color:#40c68b}.color-red[data-v-b777c97a]{color:#fe5a60}", ""]);
// Exports
module.exports = exports;
